import {hasRole} from '../../utils/hasRole';
import React, {useState, useEffect, useRef} from 'react';
import {financePermissions} from '../../utils/financePermissions';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {Button} from "primereact/button";
import {SplitButton} from "primereact/splitbutton";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import download from 'js-file-download';
import {receiptPdfFilename} from '../../utils/receiptPdfFilename';
import {receiptPaymentValidation} from '../../utils/receiptPaymentValidation';
import { TabPanel } from 'primereact/tabview';
import { TabView } from 'primereact/tabview';
import {Calendar} from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import {Dialog} from 'primereact/dialog';

import TmpFormComponent from "../../components/2.1/_tmp/TmpFormComponent";

import ReceiptFormComponent from "../../components/2.1/finance/receipt/ReceiptFormComponent";
import ReceiptUnavailable, {closeReceipt} from '../../components/2.1/finance/receipt/ReceiptUnavailable';
import ReceiptListComponent from "../../components/2.1/finance/receipt/ReceiptListComponent";
import RetentioncategoryListComponent
  from "../../components/2.1/finance/retention-category/RetentioncategoryListComponent";
import RetentioncategoryFormComponent
  from "../../components/2.1/finance/retention-category/RetentioncategoryFormComponent";
import RetentionListComponent from "../../components/2.1/finance/retention/RetentionListComponent";
import RetentionFormComponent from "../../components/2.1/finance/retention/RetentionFormComponent";
import ReceiptgroupFormComponent from '../../components/2.1/finance/receiptgroup/ReceiptgroupFormComponent';
import ReceiptgroupListComponent from '../../components/2.1/finance/receiptgroup/ReceiptgroupListComponent';
import PaymentmethodListComponent from '../../components/2.1/finance/paymentmethod/PaymentmethodListComponent';
import PaymentmethodFormComponent from '../../components/2.1/finance/paymentmethod/PaymentmethodFormComponent';
import CosttypeListComponent from "../../components/2.1/finance/costtype/CosttypeListComponent";
import CosttypeFormComponent from "../../components/2.1/finance/costtype/CosttypeFormComponent";
import FinanceDashboardComponent from "../../components/2.1/finance/FinanceDashboardComponent";
import BanktransactionListComponent from '../../components/2.1/finance/transaction/BanktransactionListComponent';
import BanktransactionShowComponent from '../../components/2.1/finance/transaction/BanktransactionShowComponent';
import ReceiptShowComponent from "../../components/2.1/finance/receipt/ReceiptShowComponent";
import BankaccountNumberListComponent from "../../components/2.1/finance/bankaccountnumber/BankaccountNumberListComponent";
import BankaccountNumberFormComponent from "../../components/2.1/finance/bankaccountnumber/BankaccountNumberFormComponent";
import VatrateListComponent from "../../components/2.1/finance/vatrate/VatrateListComponent";
import VatrateFormComponent from "../../components/2.1/finance/vatrate/VatrateFormComponent";
import CostcenterFormComponent from '../../components/2.1/finance/constcenter/CostcenterFormComponent';
import CostcenterListComponent from '../../components/2.1/finance/constcenter/CostcenterListComponent';
import CostitemFormComponent from '../../components/2.1/finance/costitem/CostitemFormComponent';
import CostitemListComponent from '../../components/2.1/finance/costitem/CostitemListComponent';
import CostitemShowComponent from '../../components/2.1/finance/costitem/CostitemShowComponent';
import CostallocationListComponent from '../../components/2.1/finance/costitem/CostallocationListComponent';
import CostallocationApproveListComponent from '../../components/2.1/finance/costallocationapprove/CostallocationApproveListComponent';
import InventorydocumentListComponent from "../../components/2.1/inventory/inventorydocument/InventorydocumentListComponent";
import ProfitcenterListComponent from '../../components/2.1/finance/profitcenter/ProfitcenterListComponent';
import ProfitcenterFormComponent from '../../components/2.1/finance/profitcenter/ProfitcenterFormComponent';
import PartnerListComponent from '../../components/2.1/partner/PartnerListComponent';
import ReceiptCostImportComponent from '../../components/2.0/receipt/ReceiptCostImportComponent';
import ReceiptSendComponent from '../../components/2.0/receipt/ReceiptSendComponent';
import ReceiptSzamlazzhuImportComponent from '../../components/2.0/receipt/ReceiptSzamlazzhuImportComponent';
import ProfitcenterShowComponent from '../../components/2.1/finance/profitcenter/ProfitcenterShowComponent';
import CosttypeShowComponent from '../../components/2.1/finance/costtype/CosttypeShowComponent';
import CostcenterShowComponent from '../../components/2.1/finance/constcenter/CostcenterShowComponent';
import InventorydocumentShowComponent from '../../components/2.1/inventory/inventorydocument/InventorydocumentShowComponent';
import InvoiceApprovalListComponent from '../../components/2.1/finance/invoiceapproval/InvoiceApprovalListComponent';
import ReceiptRevenueAllocationListComponent from '../../components/2.1/finance/receipt/ReceiptRevenueAllocationListComponent';
import RevenueitemListComponent from '../../components/2.1/finance/revenueitem/RevenueitemListComponent';
import RevenueitemShowComponent from '../../components/2.1/finance/revenueitem/RevenueitemShowComponent';
import ExchangerateListComponent from '../../components/2.1/finance/exchangerate/ExchangerateListComponent';
import ExchangerateFormComponent from '../../components/2.1/finance/exchangerate/ExchangerateFormComponent';
import ReceiptImportFormComponent from '../../components/2.1/finance/receiptimport/ReceiptImportFormComponent';
import ReceiptImportListComponent from '../../components/2.1/finance/receiptimport/ReceiptImportListComponent';



export const FinancePage = (props) => {

  const {t} = props;
  const history = useHistory();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const {entity, action, id} = useParams();
  const [receiptAccess, setReceiptAccess] = useState(null);
  useEffect(() => {
    let active = true;
    setReceiptAccess(null);
    if (entity !== 'receipt' || !id || !['read', 'update'].includes(action)) return;
    axios.get(`${process.env.REACT_APP_API_HOST}/api/v2/receipt/${id}`, {headers: {
      Authorization: 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId'),
    }}).then(response => {
      if (active) {
        const data = response.data?.data;
        if (action === 'update' && data && !data.deleted_at) {
          if (!hasRole('ROLE_RECEIPT_WRITE') || !data.draft) {
            history.replace('/finance/receipt/read/' + id);
          } else {
            window.App.setState({props: data, sidebarReceiptUpdate: true});
          }
        }
        setReceiptAccess({id, missing: !!data?.deleted_at, error: null});
      }
    }).catch(error => {
      if (active) setReceiptAccess({id, missing: [404, 410].includes(error.response?.status), error: error.response?.data?.message || t('toastError')});
    });
    return () => { active = false; };
  }, [entity, action, id, t, history]);
  const [loading, setLoading] = useState(false);
  const [currentReceipt, setCurrentReceipt] = useState(null);
  const [correctionActionTarget, setCorrectionActionTarget] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [availableActions, setAvailableActions] = useState([]);
  const [actionDialogVisible, setActionDialogVisible] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [actionNote, setActionNote] = useState('');
  const [approvedForPaymentDate, setApprovedForPaymentDate] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);
  const [paidAmountError, setPaidAmountError] = useState('');
  const [actionFormError, setActionFormError] = useState('');
  const [actionLoading, setActionLoading] = useState(false);
  const [financeDashboardId, setFinanceDashboardId] = useState(null);
  const [invoiceApprovalDetailedSearchVisible, setInvoiceApprovalDetailedSearchVisible] = useState(false);
  const [invoiceApprovalDetailedSearchActive, setInvoiceApprovalDetailedSearchActive] = useState(false);
  const [receipt, setReceipt] = useState({});
  const [costItem, setCostItem] = useState({});
  const [revenueItem, setRevenueItem] = useState({});
  const [advanceInvoiceGroups, setAdvanceInvoiceGroups] = useState([]);
  const [advanceInvoiceLoading, setAdvanceInvoiceLoading] = useState(false);
  const [advanceInvoiceDialogVisible, setAdvanceInvoiceDialogVisible] = useState(false);
  const [advanceInvoiceSummary, setAdvanceInvoiceSummary] = useState(null);
  const [advanceInvoiceSummaryLoading, setAdvanceInvoiceSummaryLoading] = useState(false);
  const [advanceInvoiceGroupId, setAdvanceInvoiceGroupId] = useState(null);
  const [profitCenter, setProfitCenter] = useState({})
  const [costType, setCostType] = useState({});
  const [costCenter, setCostCenter] = useState({})

  const urlVars = window.App && typeof window.App.urlVars === 'function'
    ? window.App.urlVars()
    : {};
  const fromReceiptGroup = urlVars.from === 'receiptgroup';
  const receiptGroupFromUrl = urlVars.receipt_group
    ? Number(urlVars.receipt_group)
    : null;
  const receiptTypeFromUrl = urlVars.receipt_type || null;
  const receiptGroupNameFromUrl = urlVars.receipt_group_name
    ? decodeURIComponent(urlVars.receipt_group_name)
    : null;

  const receiptForActions = currentReceipt || history.location.state || null;
  const canCreateAdvanceInvoice = receiptForActions?.receipt_type === 'CUSTOMER_PROFORMA' && receiptForActions?.draft === false;

  useEffect(() => {
    if (!canCreateAdvanceInvoice) {
      setAdvanceInvoiceGroups([]);
      return;
    }

    axios.get(
      process.env.REACT_APP_API_HOST + '/api/v2/receipt-group?search[receipt_type][operator]==&search[receipt_type][value]=CUSTOMER_ADVANCE_INVOICE&search[external][operator]==&search[external][value]=false',
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }
    )
      .then(response => setAdvanceInvoiceGroups(response?.data?.data?.items || []))
      .catch(error => {
        setAdvanceInvoiceGroups([]);
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [canCreateAdvanceInvoice]);

  const openAdvanceInvoiceDialog = (receiptGroupId) => {
    if (!receiptForActions?.id || !receiptGroupId) return;
    setAdvanceInvoiceGroupId(receiptGroupId);
    setAdvanceInvoiceDialogVisible(true);
    setAdvanceInvoiceSummaryLoading(true);
    axios.get(
      process.env.REACT_APP_API_HOST + `/api/v2/receipt/${receiptForActions.id}/advance-invoice-summary`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }
    )
      .then(response => setAdvanceInvoiceSummary(response?.data?.data || null))
      .catch(error => {
        setAdvanceInvoiceSummary(null);
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setAdvanceInvoiceSummaryLoading(false));
  };

  const createAdvanceInvoice = () => {
    const receiptGroupId = advanceInvoiceGroupId;
    if (!receiptForActions?.id || !receiptGroupId || advanceInvoiceLoading) return;
    setAdvanceInvoiceLoading(true);
    axios.post(
      process.env.REACT_APP_API_HOST + `/api/v2/receipt/${receiptForActions.id}/create-advance-invoice/${receiptGroupId}`,
      {},
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }
    )
      .then(response => {
        const createdReceipt = response?.data?.data;
        window.App.toastShow('success', t('success'), t('advanceInvoiceCreated'));
        setAdvanceInvoiceDialogVisible(false);
        setAdvanceInvoiceSummary(null);
        window.App.setState({
          rerenderReceiptList: Math.random(),
          sidebarReceiptUpdate: true,
          props: {
            ...createdReceipt,
            receiptgroupId: receiptGroupId
          }
        });
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setAdvanceInvoiceLoading(false));
  };

  const advanceInvoiceButton = canCreateAdvanceInvoice ? (
    <SplitButton
      type="button"
      label={t('createAdvanceInvoice')}
      icon="pi pi-plus"
      className="p-button-success"
      loading={advanceInvoiceLoading}
      disabled={advanceInvoiceLoading || advanceInvoiceGroups.length === 0}
      tooltip={advanceInvoiceGroups.length === 0 ? t('noCustomerAdvanceInvoiceGroup') : undefined}
      tooltipOptions={{position: 'top'}}
      onClick={() => openAdvanceInvoiceDialog(advanceInvoiceGroups[0]?.id)}
      model={advanceInvoiceGroups.map(group => ({
        label: group.name,
        icon: 'pi pi-file',
        command: () => openAdvanceInvoiceDialog(group.id)
      }))}
    />
  ) : null;

  const actionLabels = {
    ADD_COMMENT: t("ADD_COMMENT"),
    ALLOCATE: t("ALLOCATE"),
    MARK_READY_FOR_ACCOUNTING: t("MARK_READY_FOR_ACCOUNTING"),
    MARK_ACCOUNTING_RECEIVED: t("MARK_ACCOUNTING_RECEIVED"),
    MARK_ACCOUNTING_DONE: t("MARK_ACCOUNTING_DONE"),
    APPROVE_FOR_PAYMENT: t("APPROVE_FOR_PAYMENT"),
    MARK_PAID: t("MARK_PAID"),
    REVIEWED: t("REVIEWED")
  };

  const actionConfig = {
    ADD_COMMENT: {
      label: t("ADD_COMMENT"),
      icon: "pi pi-comment",
      className: "p-button-warning"
    },
    ALLOCATE: {
      label: t("ALLOCATE"),
      icon: "pi pi-book",
      className: "p-button-info"
    },
    MARK_READY_FOR_ACCOUNTING: {
      label: t("MARK_READY_FOR_ACCOUNTING"),
      icon: "pi pi-check-circle",
      className: "p-button-help"
    },
    MARK_ACCOUNTING_DONE: {
      label: t("MARK_ACCOUNTING_DONE"),
      icon: "pi pi-check-circle",
      className: "p-button-success"
    },
    MARK_ACCOUNTING_RECEIVED: {
      label: t("MARK_ACCOUNTING_RECEIVED"),
      icon: "pi pi-inbox",
      className: "p-button-secondary"
    },
    APPROVE_FOR_PAYMENT: {
      label: t("APPROVE_FOR_PAYMENT"),
      icon: "pi pi-wallet",
      className: "p-button-success"
    },
    MARK_PAID: {
      label: t("MARK_PAID"),
      icon: "pi pi-check",
      className: "p-button-success"
    },
    REVIEWED: {
      label: t("REVIEWED"),
      icon: "pi pi-check",
      className: "p-button-success"
    }
  };

  const formatDateForApi = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatAdvanceAmount = (amount, currency) => {
    if (window.App && typeof window.App.currencyFormatter === 'function') {
      return window.App.currencyFormatter(currency, Number(amount || 0));
    }

    const currencyCode = (currency || '').toUpperCase();
    const currencySymbols = {HUF: 'Ft', EUR: '€', USD: '$', GBP: '£'};
    const precision = currencyCode === 'HUF' ? 0 : 2;
    const formattedAmount = new Intl.NumberFormat(
      localStorage.getItem('language') || 'hu-HU',
      {minimumFractionDigits: precision, maximumFractionDigits: precision}
    ).format(Number(amount || 0));

    return <>{formattedAmount}&nbsp;{currencySymbols[currencyCode] || currencyCode}</>;
  };

  const handleActionSubmit = () => {
    if (!selectedAction) return;
    setPaidAmountError('');
    setActionFormError('');
    setActionLoading(true);
    const actionEndpoint = selectedAction.toLowerCase();
    const payload = {
      note: actionNote
    };
    if (selectedAction === 'APPROVE_FOR_PAYMENT') {
      payload.approvedForPaymentDate = formatDateForApi(approvedForPaymentDate);
    }
    if (selectedAction === 'MARK_PAID') {
      payload.paidAmount = paidAmount;
    }
    axios.post(`${process.env.REACT_APP_API_HOST}/api/v2/receipt/${id}/actions/${actionEndpoint}`, payload,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }
    )
    .then(() => {
      window.App.toastShow('success', t('toastSuccess'));
      setActionDialogVisible(false);
      setActionNote('');
      setApprovedForPaymentDate(null);
      setPaidAmount(null);
      setRefreshTrigger(prev => prev + 1);
    })
    .catch(error => {
      const validation = selectedAction === 'MARK_PAID' ? receiptPaymentValidation(error) : null;
      if (validation) {
        setPaidAmountError(validation.amount);
        setActionFormError(validation.general);
        return;
      }
      window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
    })
    .finally(() => setActionLoading(false));
  };

  const canDeleteReceipt = (() => {
    const r = receiptForActions;
    if (!r?.id) return false;
    if (r.draft === true) return true;
    if (r.external === true) return false;
    if (r.receipt_type === 'FEE_REQUEST') return true;
    return false;
  })();

  const canDownloadReceipt = (() => {
    const r = receiptForActions;
    return !!(r?.id && r?.outgoing === true);
  })();

  const fetchReceiptDownloadPdfService = (receiptId) => {
    return axios.get(
      process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + receiptId + "/download/pdf",
      {
        responseType: 'blob',
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }
    );
  };

  const handleDownload = () => {
    const r = receiptForActions;
    if (!r?.id) return;
    fetchReceiptDownloadPdfService(r.id)
      .then(response => {
        window.App.toastShow('success', t('toastDownloadSuccess'));
        download(
          response.data,
          receiptPdfFilename(r)
        );
      })
      .catch(error => {
        window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
      });
  };

  const handleDelete = () => {
    const r = receiptForActions;
    if (!r?.id) return;
    if (window.confirm(t('confirmDelete'))) {
      setLoading(true);
      // ReceiptDeleteService(r.id)
      axios.delete(
        process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + r.id,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
              'App-Network': localStorage.getItem("networkId")
            }
          }
        )
        .then(() => {
          window.App.toastShow('success', t('toastDeleteSuccess'));
          window.App.setState({
            rerenderReceiptList: true,
            sidebarReceiptUpdate: false,
            sidebarReceiptCreate: false,
            sidebarReceiptShow: false,
          });
          setReceipt({});
          setCurrentReceipt(null);
          setAvailableActions([]);
          closeReceipt(history);
        })
        .catch(error => {
          window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    }
  };


  useEffect(() => {
    document.title = 'Finance' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('finance')[0]) {
        document.getElementsByClassName('finance')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerender_FinancePage]);

  const prevSidebarReceiptUpdate = useRef(window.App.state.sidebarReceiptUpdate);

  useEffect(() => {
    const current = window.App.state.sidebarReceiptUpdate;
    const prev = prevSidebarReceiptUpdate.current;
    if (prev === true && current === false && entity === 'receipt' && action === 'read') {
      setRefreshTrigger(prev => prev + 1);
    }
    prevSidebarReceiptUpdate.current = current;
  }, [window.App.state.sidebarReceiptUpdate, entity, action]);

  useEffect(() => {
    if ((entity === 'receipt' || entity === 'invoice-approval') && action === 'read' && id) {
      axios.get(`${process.env.REACT_APP_API_HOST}/api/v2/receipt/${id}/actions`, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => setAvailableActions(response.data?.data?.actions || []))
      .catch(error => console.error("Hiba a műveletek lekérésekor", error));
    }
  }, [id, entity, action, refreshTrigger]);

  if (entity === 'receipt' && id && ['read', 'update'].includes(action)) {
    if (receiptAccess?.id !== id) return <div className="p-p-4"><i className="pi pi-spin pi-spinner" /></div>;
    if (receiptAccess.missing) return <ReceiptUnavailable />;
    if (receiptAccess.error) return <div className="p-p-4" role="alert">{receiptAccess.error}</div>;
  }
  return (
    <div className={"FinancePage"}>


      {localStorage.getItem('module_finance') ? (
        <>
          {!entity && (
            <>
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <ReceiptListComponent view="simple"
                receiptGroup={fromReceiptGroup ? receiptGroupFromUrl : undefined}
                receiptType={fromReceiptGroup ? receiptTypeFromUrl : undefined}
                receiptGroupName={fromReceiptGroup ? receiptGroupNameFromUrl : undefined}/>
            </div>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptList} closeOnEscape={true}
                        style={{width: '100%'}}
                        onHide={() => window.App.setState({
                          sidebarReceiptList: false,
                          lazyparamsReceiptList: null,
                        })}>
                <ReceiptListComponent view="advanced"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptCostCreate} closeOnEscape={true}
                        style={{width: '98%'}}
                        onHide={() => window.App.setState({
                          rerenderReceiptList: true,
                          sidebarReceiptCostCreate: false,
                          newPartnerId: null,
                          newPartnerName: null
                        })}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={hasRole('ROLE_RECEIPT_WRITE') && window.App.state.sidebarReceiptUpdate} closeOnEscape={true}
                        style={{width: '98%'}}
                        onHide={() => window.App.setState({
                          rerenderReceiptList: true,
                          sidebarReceiptUpdate: false,
                          newPartnerId: null,
                          newPartnerName: null
                        })}>
                <ReceiptFormComponent method="put" initialValues={window.App.state.props}/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptInvoiceCreate} closeOnEscape={true}
                        style={{width: '98%'}}
                        onHide={() => {
                          window.App.setState({
                            rerenderReceiptList: true,
                            sidebarReceiptInvoiceCreate: false,
                            newPartnerId: null,
                            newPartnerName: null
                          })
                        }}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptDeliveryNoteCreate} closeOnEscape={true}
                        style={{width: '98%'}}
                        onHide={() => {
                          window.App.setState({
                            rerenderReceiptList: true,
                            sidebarReceiptDeliveryNoteCreate: false,
                            newPartnerId: null,
                            newPartnerName: null
                          })
                        }}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptFeeRequestCreate} closeOnEscape={true}
                        style={{width: '98%'}}
                        onHide={() => {
                          window.App.setState({
                            rerenderReceiptList: true,
                            sidebarReceiptFeeRequestCreate: false,
                            newPartnerId: null,
                            newPartnerName: null
                          })
                        }}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptCostImport} closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          window.App.setState({
                            sidebarReceiptCostImport: false,
                            newPartnerId: null,
                            newPartnerName: null
                          })
                        }}>
                <h2 className={"text-primary"}>{t('costReceiptImport')}</h2>
                <ReceiptCostImportComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptSzamlazzhuImport} closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          window.App.setState({
                            sidebarReceiptSzamlazzhuImport: false,
                            newPartnerId: null,
                            newPartnerName: null
                          })
                        }}>
                <h2 className={"text-primary"}>{t('szamlazzHuImport')}</h2>
                <ReceiptSzamlazzhuImportComponent method="post"/>
              </Sidebar>
              {/* <Sidebar position="left" visible={window.App.state.sidebarReceiptShow} closeOnEscape={true}
                      style={{width: '980px'}}
                      onHide={() => window.App.setState({
                        rerenderReceiptList: true,
                        sidebarReceiptShow: false,
                        newPartnerId: null,
                        newPartnerName: null
                      })}>
              </Sidebar> */}
            </>
          )}

          <Dialog visible={window.App.state.dialogReceiptSend}
                  style={{width: '450px'}}
                  header={t('invoiceEmailDelivery')}
                  modal
                  onHide={() => {
                    window.App.setState({dialogReceiptSend: false})
                  }}>
            <ReceiptSendComponent/>
          </Dialog>


          {entity === 'dashboard' && hasRole('ROLE_FINANCE_MODULE_DASHBOARD') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <FinanceDashboardComponent />
            </div>
          }

          {!entity &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/tmp')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      Tmp {id ? (<>módosítása</>) : (<>létrehozása</>)}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/tmp')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <TmpFormComponent backlink={'/tmp'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }


          {(entity === 'invoice-approval') && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_invoice_approval_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('invoiceApproval')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <Button
                    type="button"
                    label={t('detailedSearch')}
                    icon={invoiceApprovalDetailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                    className="p-button-outlined p-mr-2"
                    onClick={() => {
                      setInvoiceApprovalDetailedSearchVisible(prev => !prev);
                    }}
                  />
                  {/* {(localStorage.getItem('roles') || '[]').includes('role_invoice_approval_write') && (
                    <a onClick={() => {
                      history.push('/finance/invoice-approval/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addInvoiceApproval')}
                    </a>
                  )} */}
                </div>
              </div>
              <Panel>
                <InvoiceApprovalListComponent
                  backlink={'/finance/invoice-approval'}
                  detailedSearchVisible={invoiceApprovalDetailedSearchVisible}
                  onDetailedSearchActiveChange={setInvoiceApprovalDetailedSearchActive}
                />
              </Panel>
            </div>
          }
          {entity === 'invoice-approval' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: '780px'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/finance/invoice-approval')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('invoiceApprovalUpdate') : t('invoiceApprovalCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/finance/invoice-approval')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <TmpFormComponent backlink={'/finance/invoice-approval'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }

          {(entity === 'invoice-approval') && action === 'read' &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className="p-d-flex p-jc-between p-ai-center p-mb-4 p-flex-wrap" style={{ rowGap: '1rem' }}>
                      <h2 className="p-m-0 p-p-0 text-primary">
                        {[
                          receipt?.receipt_group?.name || receipt?.receipt_group_name,
                          receipt?.receipt_number
                        ].filter(Boolean).join(' • ')}
                      </h2>
                      <div className="p-d-flex p-ai-center p-jc-end" style={{ gap: '0.5rem' }}>
                          <Button
                            type="button"
                            label={t('delete')}
                            icon="pi pi-trash"
                            className="p-button-danger"
                            loading={loading}
                            onClick={handleDelete}
                          />
                          {/* <Button
                            type="button"
                            label={t('approve')}
                            icon="pi pi-check"
                            className="p-button-success"
                            loading={loading}
                            onClick={() => {
                              setLoading(true);
                              apiCall('post', `/api/v2/receipt/${id}/actions/reviewed`, {})
                                .then(response => {
                                  window.App.toastShow('success', t('success'), t('toastInvoiceApprovedSuccess'));
                                  history.push('/finance/invoice-approvals/list');
                                })
                                .catch(error => {
                                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                })
                                .finally(() => {
                                  setLoading(false);
                                });
                             } }
                          /> */}
                          {availableActions.map(actKey => (
                            <Button
                              key={actKey}
                              type="button"
                              label={actionConfig[actKey]?.label || actKey}
                              icon={actionConfig[actKey]?.icon || "pi pi-tag"}
                              className={actionConfig[actKey]?.className || "p-button-outlined"}
                              onClick={() => {
                                setSelectedAction(actKey);
                                setPaidAmountError('');
                                setActionFormError('');
                                setActionNote('');
                                setApprovedForPaymentDate(null);
                                setPaidAmount(null);
                                setActionDialogVisible(true);
                              }}
                            />
                          ))}
                          {advanceInvoiceButton}
                        <span ref={setCorrectionActionTarget} style={{display: 'contents'}} />
                        <Button
                          label={t('back')}
                          icon="pi pi-arrow-left"
                          className="p-button-secondary"
                          onClick={() => {
                            const from = history.location?.state?.from;
                            if (from) {
                              history.push(from);
                            } else {
                              history.goBack();
                            }
                          }}
                        />
                      </div>
                    </div>
                    <Panel>
                      <ReceiptShowComponent key={`${action}-${id}`} initialValues={{id: Number(id)}}
                      correctionActionTarget={correctionActionTarget} onLoad={(data) => setCurrentReceipt(data)} refreshTrigger={refreshTrigger} onLoaded={(receipt) => setReceipt(receipt || {})} />
                    </Panel>
                  </div>
                }

          {entity === 'retention' && localStorage.getItem('roles').toString().includes('role_retention_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('retentionList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
                            </span>
                        {/*<a onClick={() => {*/}
                        {/*  history.push('/finance/retention/create')*/}
                        {/*}}*/}
                        {/*   className={"p-button  p-button-success p-ml-2"}>*/}
                        {/*  <i className={"pi pi-plus"}></i>*/}
                        {/*  &nbsp;*/}
                        {/*  Új visszatartás*/}
                        {/*</a>*/}
                      </div>
                    </div>
                    <Panel>
                      <RetentionListComponent/>
                    </Panel>
                  </div>
                }
                {entity === 'retention' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                           showCloseIcon={false}
                           visible={action === 'create' || action === 'update'}
                           closeOnEscape={true}
                           style={{width: '780px'}}
                           onHide={() => {
                             history.push('/finance/retention')
                           }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {id && id !== 'undefined' ? t('retentionUpdate') : t('retentionCreate')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>

                            </span>
                          <a onClick={() => {
                            history.push('/finance/retention')
                          }}
                             className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            {t('back')}
                          </a>
                        </div>
                      </div>
                      <Panel>
                        <RetentionFormComponent backlink={'/finance/retention'}/>
                      </Panel>
                    </div>
                  </Sidebar>
                }

                {entity === 'retention-category' && localStorage.getItem('roles').toString().includes('role_retention_category_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('retentionCategories')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>
                        </span>
                        {(localStorage.getItem('roles') || '[]').includes('role_retention_category_write') && (
                          <a onClick={() => {
                            history.push('/finance/retention-category/create')
                          }}
                              className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addRetentionCategory')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <RetentioncategoryListComponent/>
                    </Panel>
                  </div>
                }
                {entity === 'retention-category' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                            showCloseIcon={false}
                            visible={action === 'create' || action === 'update'}
                            closeOnEscape={true}
                            style={{width: '780px'}}
                            onHide={() => {
                              history.push('/finance/retention-category')
                            }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {id && id !== 'undefined' ? t('retentionCategoryUpdate') : t('retentionCategoryCreate')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>

                            </span>
                          <a onClick={() => {
                            history.push('/finance/retention-category')
                          }}
                              className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            {t('back')}
                          </a>
                        </div>
                      </div>
                      <Panel>
                        <RetentioncategoryFormComponent backlink={'/finance/retention-category'}/>
                      </Panel>
                    </div>
                  </Sidebar>
                }


                {entity === 'payment-method' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_payment_method_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('paymentMethodList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                        {(localStorage.getItem('roles') || '[]').includes('role_payment_method_write') && (
                          <a onClick={() => {
                            history.push('/finance/payment-method/create')
                          }}
                              className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addPaymentMethod')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <PaymentmethodListComponent backlink={'/finance/payment-method'}/>
                    </Panel>
                  </div>
                }
                {entity === 'payment-method' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                            showCloseIcon={false}
                            visible={action === 'create' || action === 'update'}
                            closeOnEscape={true}
                            style={{width: '780px'}}
                            onHide={() => {
                              if (action === 'create' || action === 'update') {
                                history.push('/finance/payment-method')
                              }
                            }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {id ? t('paymentMethodUpdate') : t('paymentMethodCreate')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                          <a onClick={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/payment-method')
                            }
                          }}
                              className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            {t('back')}
                          </a>
                        </div>
                      </div>
                      <Panel>
                        {(action === 'create' || action === 'update') &&
                          <PaymentmethodFormComponent initialValues={window.App.state.props} backlink={'/finance/payment-method'}/>
                        }
                      </Panel>
                    </div>
                  </Sidebar>
                }


                {entity === 'cost-type' && (!action || action === 'update' || action === 'create') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('costTypeList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                        {(localStorage.getItem('roles') || '[]').includes('role_cost_type_write') && (
                          <a onClick={() => {
                            history.push('/finance/cost-type/create')
                          }}
                              className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addCostType')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <CosttypeListComponent backlink={'/finance/cost-type'}  view={window.App.urlVars().view} entity={'cost-type'}/>
                    </Panel>
                  </div>
                }
                {entity === 'cost-type' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                            showCloseIcon={false}
                            visible={action === 'create' || action === 'update'}
                            closeOnEscape={true}
                            style={{width: '780px'}}
                            onHide={() => {
                              if (action === 'create' || action === 'update') {
                                history.push('/finance/cost-type')
                              }
                            }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {id ? t('costTypeUpdate') : t('costTypeCreate')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                          <a onClick={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/cost-type')
                            }
                          }}
                              className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            {t('back')}
                          </a>
                        </div>
                      </div>
                      <Panel>
                        {(action === 'create' || action === 'update') &&
                          <CosttypeFormComponent key={`${entity}-${action}-${id || 'new'}`} initialValues={action === 'update' ? window.App.state.props : {}} backlink={'/finance/cost-type'}/>
                        }
                      </Panel>
                    </div>
                  </Sidebar>
                }
                {entity === 'cost-type' && action === 'read' && (
                  <div className="PageContent p-p-5 p-mx-auto">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                          {costType?.name}
                        </h2>
                      </div>

                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <a
                          onClick={() => {
                            history.push('/finance/cost-type');
                          }}
                          className="p-button p-button-secondary p-ml-2"
                        >
                          <i className="pi pi-arrow-left"></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>

                    <Panel>
                      <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                        <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6"}>
                              <div className={"p-grid"}>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                    {t('columnName')}
                                  </h3>
                                </div>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                                </div>
                              </div>
                              <CosttypeShowComponent view={window.App.urlVars().view} entity={'cost-type'}  backlink={'/finance/cost-type'} onLoaded={(costType) => setCostType(costType || {})} />
                            </div>
                          </div>
                        </TabPanel>
                        {hasRole('ROLE_COST_TYPE_DASHBOARD') && <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                          <FinanceDashboardComponent key={financeDashboardId} dashboardId={financeDashboardId} allowRouteIdFallback={false} />
                        </TabPanel>}
                      </TabView>
                    </Panel>
                  </div>
                )}


                {entity === 'book' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_receipt_group_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('receiptGroups')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                        {localStorage.getItem('roles').toString().includes('role_receipt_group_read') && (
                          <a onClick={() => {
                            history.push('/finance/book/create')
                          }}
                              className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addReceiptGroup')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <ReceiptgroupListComponent backlink={'/finance/book'}/>
                    </Panel>
                  </div>
                }
                {entity === 'book' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                            showCloseIcon={false}
                            visible={action === 'create' || action === 'update'}
                            closeOnEscape={true}
                            style={{width: '780px'}}
                            onHide={() => {
                              if (action === 'create' || action === 'update') {
                                history.push('/finance/book')
                              }
                            }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {id ? t('receiptGroupUpdate') : t('receiptGroupCreate')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                          <a onClick={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/book')
                            }
                          }}
                              className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            {t('back')}
                          </a>
                        </div>
                      </div>
                      <Panel>
                        {(action === 'create' || action === 'update') &&
                          <ReceiptgroupFormComponent initialValues={action === 'update' ? { id: id } : {}} backlink={'/finance/book'}/>
                        }
                      </Panel>
                    </div>
                  </Sidebar>
                }



                {entity === 'profit-center' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_profit_center_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('profitCenterList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                        {(localStorage.getItem('roles') || '[]').includes('role_profit_center_write') && (
                          <a onClick={() => {
                            history.push('/finance/profit-center/create')
                          }}
                              className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addProfitCenter')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <ProfitcenterListComponent backlink={'/finance/profit-center'}  view={window.App.urlVars().view} entity={'profit-center'}/>
                    </Panel>
                  </div>
                }
                {entity === 'profit-center' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                            showCloseIcon={false}
                            visible={action === 'create' || action === 'update'}
                            closeOnEscape={true}
                            style={{width: '780px'}}
                            onHide={() => {
                              if (action === 'create' || action === 'update') {
                                history.push('/finance/profit-center')
                              }
                            }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {id ? t('profitCenterUpdate') : t('profitCenterCreate')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                          <a onClick={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/profit-center')
                            }
                          }}
                              className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            {t('back')}
                          </a>
                        </div>
                      </div>
                      <Panel>
                        {(action === 'create' || action === 'update') &&
                          <ProfitcenterFormComponent backlink={'/finance/profit-center'}/>
                        }
                      </Panel>
                    </div>
                  </Sidebar>
                }

                {entity === 'cost-center' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_cost_center_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('costCenterList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                        {(localStorage.getItem('roles') || '[]').includes('role_cost_center_write') && (
                          <a onClick={() => {
                            history.push('/finance/cost-center/create')
                          }}
                              className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addCostCenter')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <CostcenterListComponent backlink={'/finance/cost-center'} view={window.App.urlVars().view} entity={'cost-center'}/>
                    </Panel>
                  </div>
                }

                {entity === 'cost-center' && action === 'read' && (
                  <div className="PageContent p-p-5 p-mx-auto">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                          {costCenter?.name}
                        </h2>
                      </div>

                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <a
                          onClick={() => {
                            history.push('/finance/cost-center');
                          }}
                          className="p-button p-button-secondary p-ml-2"
                        >
                          <i className="pi pi-arrow-left"></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>

                    <Panel>
                      <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                        <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6"}>
                              <div className={"p-grid"}>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                    {t('columnName')}
                                  </h3>
                                </div>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                                </div>
                              </div>
                              <CostcenterShowComponent view={window.App.urlVars().view} entity={'cost-center'}  backlink={'/finance/cost-center'} onLoaded={(costCenter) => setCostCenter(costCenter || {})} />
                            </div>
                          </div>
                        </TabPanel>
                        {hasRole('ROLE_COST_CENTER_DASHBOARD') && <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                          <FinanceDashboardComponent key={financeDashboardId} dashboardId={financeDashboardId} allowRouteIdFallback={false} />
                        </TabPanel>}
                      </TabView>
                    </Panel>
                  </div>
                )}

                {entity === 'profit-center' && action === 'read' && (
                  <div className="PageContent p-p-5 p-mx-auto">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                          {profitCenter?.name}
                        </h2>
                      </div>

                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <a
                          onClick={() => {
                            history.push('/finance/profit-center');
                          }}
                          className="p-button p-button-secondary p-ml-2"
                        >
                          <i className="pi pi-arrow-left"></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>

                    <Panel>
                      <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                        <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6"}>
                              <div className={"p-grid"}>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                    {t('columnName')}
                                  </h3>
                                </div>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                                </div>
                              </div>
                              <ProfitcenterShowComponent view={window.App.urlVars().view} entity={'profit-center'}  backlink={'/finance/profit-center'} onLoaded={(profitCenter) => setProfitCenter(profitCenter || {})} />
                            </div>
                          </div>
                        </TabPanel>
                        {hasRole('ROLE_PROFIT_CENTER_DASHBOARD') && <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                          <FinanceDashboardComponent key={financeDashboardId} dashboardId={financeDashboardId} allowRouteIdFallback={false} />
                        </TabPanel>}
                      </TabView>
                    </Panel>
                  </div>
                )}

                {entity === 'receipt' && (action === 'update' || action === 'create' || action === 'read') && (
                  <Sidebar
                    position="left"
                    visible={hasRole('ROLE_RECEIPT_WRITE') && window.App.state.sidebarReceiptUpdate}
                    closeOnEscape
                    style={{ width: '98%' }}
                    onHide={() => {
                      window.App.setState({
                        sidebarReceiptUpdate: false,
                        rerenderReceiptList: true,
                        newPartnerId: null,
                        newPartnerName: null
                      });
                      setRefreshTrigger(prev => prev + 1);
                      if (action === 'update') history.replace('/finance/receipt/read/' + id);
                    }}
                  >
                    <ReceiptFormComponent method="put" initialValues={window.App.state.props} />
                  </Sidebar>
                )}
                {entity === 'receipt' && action === 'read' &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className="p-d-flex p-jc-between p-ai-center p-mb-4 p-flex-wrap" style={{ rowGap: '1rem' }}>
                      <h2 className="p-m-0 p-p-0 text-primary">
                        {receipt?.receipt_number}
                      </h2>
                      <div className="p-d-flex p-ai-center p-jc-end" style={{ gap: '0.5rem' }}>
                        {canDeleteReceipt && (
                          <Button
                            type="button"
                            label={t('delete')}
                            icon="pi pi-trash"
                            className="p-button-danger"
                            loading={loading}
                            onClick={handleDelete}
                          />
                        )}
                        {availableActions.map(actKey => (
                          <Button
                            key={actKey}
                            type="button"
                            label={actionConfig[actKey]?.label || actKey}
                            icon={actionConfig[actKey]?.icon || "pi pi-tag"}
                            className={actionConfig[actKey]?.className || "p-button-outlined"}
                            onClick={() => {
                              setSelectedAction(actKey);
                              setPaidAmountError('');
                              setActionFormError('');
                              setPaidAmount(null);
                              setActionDialogVisible(true);
                            }}
                          />
                        ))}
                        {advanceInvoiceButton}
                        <Button
                          icon="pi pi-download"
                          className="p-button-secondary"
                          label={t('download')}
                          disabled={!canDownloadReceipt}
                          onClick={handleDownload}
                        />
                        {hasRole('ROLE_RECEIPT_WRITE') && <Button
                          type="button"
                          label={t('editAction')}
                          icon="pi pi-pencil"
                          className="p-button-warning"
                          disabled={history.location.state?.draft !== true && currentReceipt?.draft !== true}
                          onClick={() => {
                            const dataToEdit = currentReceipt || history.location.state;
                            if (!hasRole('ROLE_RECEIPT_WRITE') || !dataToEdit || dataToEdit.draft !== true) return;
                            let sidebarStateKey = 'sidebarReceiptUpdate';
                            const rType = dataToEdit.receipt_type;
                            if (rType === 'CUSTOMER_INVOICE' || rType === 'SUPPLIER_INVOICE' || rType === 'INVOICE') {
                                sidebarStateKey = 'sidebarReceiptUpdate';
                            } else if (['CUSTOMER_FEE_REQUEST', 'FEE_REQUEST', 'SUPPLIER_FEE_REQUEST'].includes(rType)) {
                                sidebarStateKey = 'sidebarReceiptFeeRequestCreate';
                            } else if (rType === 'DELIVERY_NOTE') {
                                sidebarStateKey = 'sidebarReceiptDeliveryNoteCreate';
                            }
                            window.App.setState({
                              [sidebarStateKey]: true,
                              props: { ...dataToEdit, id: Number(id) }
                            });
                          }}
                        />}
                        <span ref={setCorrectionActionTarget} style={{display: 'contents'}} />
                        <Button
                          label={t('back')}
                          icon="pi pi-arrow-left"
                          className="p-button-secondary"
                          onClick={() => {
                            const from = history.location?.state?.from;
                            if (from) {
                              history.push(from);
                            } else {
                              history.goBack();
                            }
                          }}
                        />
                      </div>
                    </div>
                    <Panel>
                      <ReceiptShowComponent key={`${action}-${id}`} initialValues={{id: Number(id)}}
                      correctionActionTarget={correctionActionTarget} onLoad={(data) => setCurrentReceipt(data)} refreshTrigger={refreshTrigger} onLoaded={(receipt) => setReceipt(receipt || {})} />
                    </Panel>
                  </div>
                }
                {entity === 'revenue-allocation' && financePermissions().readAllocations && (!action || action === 'update' || action === 'create') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('revenues')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                      </div>
                    </div>
                    <Panel>
                      <ReceiptRevenueAllocationListComponent backlink={'/finance/revenue-allocation'}/>
                    </Panel>
                  </div>
                }

                {entity === 'bank-transaction' && !action && localStorage.getItem('roles').toString().includes('role_bank_transaction_read') && (
                  <div className="PageContent p-p-5 p-mx-auto">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                          {t('bankTransactions')}
                        </h2>
                      </div>
                      {/* <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <a
                          onClick={() => {
                            history.push('/finance/bank-transaction/create');
                          }}
                          className="p-button p-button-success p-ml-2"
                        >
                          <i className="pi pi-plus"></i>
                          &nbsp;
                          {t('addTransaction')}
                        </a>
                      </div> */}
                    </div>

                    <Panel>
                      <BanktransactionListComponent backlink={'/finance/bank-transaction'} />
                    </Panel>
                  </div>
                )}

                {entity === 'bank-transaction' && action === 'edit' && (
                  <div className="PageContent p-p-5 p-mx-auto">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                          {t('bankTransactionShow')}
                        </h2>
                      </div>

                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <a
                          onClick={() => {
                            history.push('/finance/bank-transaction');
                          }}
                          className="p-button p-button-secondary p-ml-2"
                        >
                          <i className="pi pi-arrow-left"></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>

                    <Panel>
                      <BanktransactionShowComponent backlink={'/finance/bank-transaction'} />
                    </Panel>
                  </div>
                )}

                {entity === 'cost-item' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_cost_item_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('costItemList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                        {/* <a onClick={() => {
                          history.push('/finance/cost-item/create')
                        }}
                            className={"p-button  p-button-success p-ml-2"}>
                          <i className={"pi pi-plus"}></i>
                          &nbsp;
                          {t('addCostItem')}
                        </a> */}
                      </div>
                    </div>
                    <Panel>
                      <CostitemListComponent backlink={'/finance/cost-item'}/>
                    </Panel>
                  </div>
                }

                {entity === 'cost-item' && action === 'read' &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {costItem?.name}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <a onClick={() => {
                          history.push('/finance/cost-item')
                        }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                          <i className={"pi pi-arrow-left"}></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>

                    <Panel>
                      <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                        <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                          <div className={"p-grid"}>
                            <div className={"p-col"}>
                              <div className={"p-grid"}>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                    {t('columnName')}
                                  </h3>
                                </div>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                                </div>
                              </div>
                              <CostitemShowComponent onLoaded={(costItem) => setCostItem(costItem || {})} />
                            </div>
                          </div>
                        </TabPanel>

                        {financePermissions().readAllocations && <TabPanel header={t('tabCostAllocation')} leftIcon="pi pi-list">
                          <CostallocationListComponent costItemAmount={window.App.state?.props?.amount} />
                        </TabPanel>}
                      </TabView>
                    </Panel>
                  </div>
                }
                {entity === 'revenue-item' && action === 'read' &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {revenueItem?.name}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <a onClick={() => {
                          history.push('/finance/revenue-item')
                        }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                          <i className={"pi pi-arrow-left"}></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>

                    <Panel>
                      <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                        <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                          <div className={"p-grid"}>
                            <div className={"p-col"}>
                              <div className={"p-grid"}>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                    {t('columnName')}
                                  </h3>
                                </div>
                                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                                </div>
                              </div>
                              <RevenueitemShowComponent onLoaded={(revenueItem) => setRevenueItem(revenueItem || {})} />
                            </div>
                          </div>
                        </TabPanel>

                        {financePermissions().readAllocations && <TabPanel header={t('tabRevenueAllocation')} leftIcon="pi pi-list">
                          <ReceiptRevenueAllocationListComponent revenueId={props?.initialValues?.id || window.App.state?.props?.id} />
                        </TabPanel>}
                      </TabView>
                    </Panel>
                  </div>
                }
                {entity === 'revenue-item' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_revenue_item_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('revenueItemList')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>

                        </span>
                      </div>
                    </div>
                    <Panel>
                      <RevenueitemListComponent backlink={'/finance/revenue-item'}/>
                    </Panel>
                  </div>
                }

                {entity === 'cost-allocation' && financePermissions().readAllocations && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_cost_allocation_read') &&
                  <div className={"PageContent p-p-5 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('costApproval')}
                        </h2>
                      </div>
                    </div>
                    <Panel>
                      <CostallocationApproveListComponent backlink={'/cost-allocation'}/>
                    </Panel>
                  </div>
                }
                      {/* <Sidebar
                        position="bottom"
                        visible={window.App.urlVars().search === 'partner'}
                        closeOnEscape={true}
                        style={{ width: '100%', height: '80%' }}
                        onHide={() => {
                          history.push('/finance/bank-transaction/edit/' + id)
                        }}
                      >
                        <div className="p-grid p-mt-3">
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                              {t('partnerSearch')}
                            </h3>
                          </div>
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                          </div>
                        </div>

                        <Panel>
                          <PartnerListComponent
                          view="search"
                            backlink={'/finance/bank-transaction/edit/' + id}
                          />
                        </Panel>
                      </Sidebar> */}
              <Sidebar
                position="bottom"
                visible={window.App.urlVars().search === 'partner'}
                closeOnEscape
                style={{ width: '100%', height: '80%' }}
                onHide={() => {
                  const vars = window.App.urlVars();
                  const next = { ...vars };
                  delete next.search;
                  let q = '?';
                  Object.entries(next).forEach(([k, v]) => {
                    if (v !== undefined && v !== null && v !== '') q += `${k}=${v}&`;
                  });
                  window.location.hash = window.location.hash.replace(/\?.*$/, "") + q;
                }}
              >
                <div className="p-grid p-mt-3">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('partnerSearch')}
                    </h3>
                  </div>
                </div>
                <Panel>
                  <PartnerListComponent
                    view="search"
                    backlink={window.location.hash.replace('#', '').replace(/\?.*$/, '')}
                  />
                </Panel>
              </Sidebar>
              <Sidebar
                position="bottom"
                visible={window.App.urlVars().search === 'receiptRelationReceipt'}
                closeOnEscape={true}
                style={{ width: '100%', height: '80%' }}
                onHide={() => {
                  const basePath = history.location.pathname;
                  const params = new URLSearchParams(history.location.search);
                  params.delete('search');
                  history.push(`${basePath}?${params.toString()}`);
                }}
              >
                <div className="p-grid p-mt-3">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('receiptBrowse')}
                    </h3>
                  </div>
                </div>
                <Panel>
                  <ReceiptListComponent
                    view="search"
                    backlink={`${history.location.pathname}?${new URLSearchParams(history.location.search).toString()}`.replace(/([&?])search=[^&]+/, '')}
                    pickParam="related_receipt"
                  />
                </Panel>
              </Sidebar>
              <Sidebar
                position="bottom"
                visible={window.App.urlVars().search === 'receiptRelationInvDoc'}
                closeOnEscape={true}
                style={{ width: '100%', height: '80%' }}
                onHide={() => {
                  const basePath = history.location.pathname;
                  const params = new URLSearchParams(history.location.search);
                  params.delete('search');
                  history.push(`${basePath}?${params.toString()}`);
                }}
              >
                <div className="p-grid p-mt-3">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('deliveryNoteBrowse')}
                    </h3>
                  </div>
                </div>
                <Panel>
                  <InventorydocumentListComponent
                    view="search"
                    backlink={`${history.location.pathname}?${new URLSearchParams(history.location.search).toString()}`.replace(/([&?])search=[^&]+/, '')}
                    pickParam="inventory_document"
                  />
                </Panel>
              </Sidebar>
              {entity === 'bank-account' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_bank_account_read') &&
                <div className={"PageContent p-p-5 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('bankAccountList')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <span className={"p-mr-2"}>

                      </span>
                      {localStorage.getItem('roles').toString().includes('role_bank_account_write') && (
                        <a onClick={() => {
                          history.push('/finance/bank-account/create')
                        }}
                            className={"p-button  p-button-success p-ml-2"}>
                          <i className={"pi pi-plus"}></i>
                          &nbsp;
                          {t('addBankAccount')}
                        </a>
                      )}
                    </div>
                  </div>
                  <Panel>
                    <BankaccountNumberListComponent backlink={'/finance/bank-account'}/>
                  </Panel>
                </div>
              }
              {entity === 'bank-account' && (action === 'create' || action === 'update') &&
                <Sidebar position="left"
                          showCloseIcon={false}
                          visible={action === 'create' || action === 'update'}
                          closeOnEscape={true}
                          style={{width: '780px'}}
                          onHide={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/bank-account')
                            }
                          }}>
                  <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {id ? t('bankAccountNumberUpdate') : t('bankAccountNumberCreate')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <span className={"p-mr-2"}>

                      </span>
                        <a onClick={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/finance/bank-account')
                          }
                        }}
                            className={"p-button  p-button-secondary p-ml-2"}>
                          <i className={"pi pi-arrow-left"}></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>
                    <Panel>
                      {(action === 'create' || action === 'update') &&
                        <BankaccountNumberFormComponent backlink={'/finance/bank-account'}/>
                      }
                    </Panel>
                  </div>
                </Sidebar>
              }

              {entity === 'cost-item' && (action === 'create' || action === 'update') &&
                <Sidebar position="left"
                          showCloseIcon={false}
                          visible={action === 'create' || action === 'update'}
                          closeOnEscape={true}
                          style={{width: '780px'}}
                          onHide={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/cost-item')
                            }
                          }}>
                  <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {id ? t('costItemUpdate') : t('costItemCreate')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <span className={"p-mr-2"}>

                      </span>
                        <a onClick={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/finance/cost-item')
                          }
                        }}
                            className={"p-button  p-button-secondary p-ml-2"}>
                          <i className={"pi pi-arrow-left"}></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>
                    <Panel>
                      {(action === 'create' || action === 'update') &&
                        <CostitemFormComponent backlink={'/finance/cost-item'}/>
                      }
                    </Panel>
                  </div>
                </Sidebar>
              }

            {entity === 'vat-rate' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_vat_rate_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('vatRateList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                    {localStorage.getItem('roles').toString().includes('role_vat_rate_write') && (
                      <a onClick={() => {
                        history.push('/finance/vat-rate/create')
                      }}
                          className={"p-button  p-button-success p-ml-2"}>
                        <i className={"pi pi-plus"}></i>
                        &nbsp;
                        {t('addVatRate')}
                      </a>
                    )}
                  </div>
                </div>
                <Panel>
                  <VatrateListComponent backlink={'/finance/vat-rate'}/>
                </Panel>
              </div>
            }
            {entity === 'vat-rate' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/finance/vat-rate')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('vatRateUpdate') : t('vatRateCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/finance/vat-rate')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <VatrateFormComponent backlink={'/finance/vat-rate'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'exchange-rate' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_exchange_rate_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('exchangeRate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                    <a onClick={() => {
                      history.push('/finance/exchange-rate/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addExchangeRate')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ExchangerateListComponent backlink={'/finance/exchange-rate'}/>
                </Panel>
              </div>
            }
            {entity === 'exchange-rate' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/finance/exchange-rate')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('exchangeRateUpdate') : t('exchangeRateCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/finance/exchange-rate')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <ExchangerateFormComponent backlink={'/finance/exchange-rate'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'cost-center' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/finance/cost-center')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('costCenterUpdate') : t('costCenterCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/finance/cost-center')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <CostcenterFormComponent backlink={'/finance/cost-center'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }

            {entity === 'receipt-import' && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('receiptImports')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                    <a onClick={() => {
                      history.push('/finance/receipt-import/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addReceiptImport')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ReceiptImportListComponent backlink={'/finance/receipt-import'}/>
                </Panel>
              </div>
            }
            {entity === 'receipt-import' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/finance/receipt-import')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('receiptImportUpdate') : t('receiptImportCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/finance/receipt-import')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <ReceiptImportFormComponent backlink={'/finance/receipt-import'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }

            {entity === 'receipt' && window.App.urlVars().read === 'inventorydocument' && (
              <Sidebar
                position="left"
                showCloseIcon={false}
                visible={window.App.urlVars().read === 'inventorydocument'}
                closeOnEscape={true}
                style={{ width: '98%' }}
                onHide={() => {
                  history.push('/finance/receipt/read/' + id);
                }}
              >
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('deliveryNoteShow')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <a
                        onClick={() => {
                          history.push('/finance/receipt/read/' + id);
                        }}
                        className={"p-button p-button-secondary p-ml-2"}
                      >
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>

                  <Panel>
                    <InventorydocumentShowComponent
                      entity={'transfer-supplier'}
                      initialValues={{ id: Number(window.App.urlVars().inventoryDocumentId) }}
                      backlink={'/finance/receipt/read/' + id}
                    />

                    <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                      <TabPanel header={t('tabPreview')} leftIcon="pi pi-eye">
                        <InventorydocumentShowComponent
                          entity="transfer-supplier"
                          view="preview"
                          initialValues={{ id: Number(window.App.urlVars().inventoryDocumentId) }}
                          backlink={'/finance/receipt/read/' + id}
                        />
                      </TabPanel>
                      <TabPanel header={t('tabDocumentImage')} leftIcon="pi pi-file">
                        <InventorydocumentShowComponent
                          entity="transfer-supplier"
                          view="file"
                          initialValues={{ id: Number(window.App.urlVars().inventoryDocumentId) }}
                          backlink={'/finance/receipt/read/' + id}
                        />
                      </TabPanel>
                    </TabView>
                  </Panel>
                </div>
              </Sidebar>
            )}

            <Dialog
              header={t('createAdvanceInvoice')}
              visible={advanceInvoiceDialogVisible}
              style={{width: '520px'}}
              modal
              onHide={() => {
                if (!advanceInvoiceLoading) setAdvanceInvoiceDialogVisible(false);
              }}
              footer={
                <Button
                  label={t('createAdvanceInvoice')}
                  className="p-button-success"
                  icon="pi pi-file"
                  onClick={createAdvanceInvoice}
                  loading={advanceInvoiceLoading}
                  disabled={advanceInvoiceSummaryLoading || !advanceInvoiceSummary?.can_create}
                />
              }
            >
              {advanceInvoiceSummaryLoading ? (
                <div className="p-text-center p-p-4">
                  <i className="pi pi-spin pi-spinner" style={{fontSize: '2rem'}} />
                </div>
              ) : advanceInvoiceSummary && (
                <>
                  <div className="p-grid">
                    <div className="p-col-7">{t('proformaGrossAmount')}</div>
                    <div className="p-col-5 p-text-right p-text-bold">
                      {formatAdvanceAmount(advanceInvoiceSummary.gross_amount, advanceInvoiceSummary.currency)}
                    </div>
                    <div className="p-col-7">{t('recordedPaidAmount')}</div>
                    <div className="p-col-5 p-text-right p-text-bold">
                      {formatAdvanceAmount(advanceInvoiceSummary.paid_amount, advanceInvoiceSummary.currency)}
                    </div>
                    <div className="p-col-7">{t('advanceInvoicedAmount')}</div>
                    <div className="p-col-5 p-text-right p-text-bold">
                      {formatAdvanceAmount(advanceInvoiceSummary.advance_invoiced_amount, advanceInvoiceSummary.currency)}
                    </div>
                    <div className="p-col-7 text-primary p-text-bold">{t('availableAdvanceInvoiceAmount')}</div>
                    <div className="p-col-5 p-text-right text-primary p-text-bold">
                      {formatAdvanceAmount(advanceInvoiceSummary.available_amount, advanceInvoiceSummary.currency)}
                    </div>
                  </div>
                  {!advanceInvoiceSummary.can_create && (
                    <div className="p-message p-message-warn p-mt-3">
                      <div className="p-message-wrapper">
                        <span className="p-message-icon pi pi-exclamation-triangle" />
                        <span className="p-message-text">
                          {Number(advanceInvoiceSummary.paid_amount || 0) <= 0
                            ? t('advanceInvoiceRequiresPayment')
                            : t('advanceInvoicePaymentAlreadyCovered')}
                        </span>
                      </div>
                    </div>
                  )}
                  {advanceInvoiceSummary.can_create && (
                    <small className="p-d-block p-mt-3">
                      {t('advanceInvoiceDraftDifferenceHint')}
                    </small>
                  )}
                </>
              )}
            </Dialog>

            {/* dialog a receipt show oldalon fent lévő dinamikus gombokhoz */}
            <Dialog
              header={selectedAction ? actionLabels[selectedAction] : t('action')}
              visible={actionDialogVisible}
              style={{ width: '400px' }}
              modal
              onHide={() => {
                if(!actionLoading) setActionDialogVisible(false);
              }}
              footer={
                <Button label={t('save')} className='p-button-success p-ml-2' icon="pi pi-check" onClick={handleActionSubmit} loading={actionLoading} autoFocus />
              }
            >
              <div className="p-fluid p-mt-2">
                {actionFormError && <div className="p-error p-mb-3" role="alert">{actionFormError}</div>}
                {selectedAction === 'APPROVE_FOR_PAYMENT' && (
                  <div className="p-field">
                    <label htmlFor="approvedForPaymentDate">{t('fieldDate')}</label>
                    <Calendar
                      id="approvedForPaymentDate"
                      value={approvedForPaymentDate}
                      onChange={(e) => setApprovedForPaymentDate(e.value)}
                      dateFormat="yy-mm-dd"
                      showIcon
                    />
                  </div>
                )}

                {selectedAction === 'MARK_PAID' && (
                  <div className="p-field">
                    <label htmlFor="paidAmount" className={paidAmountError ? 'p-error' : ''}>{t('fieldAmount')}</label>
                    <InputNumber
                      inputId="paidAmount"
                      value={paidAmount}
                      onChange={(e) => { setPaidAmount(e.value); setPaidAmountError(''); }}
                      onValueChange={(e) => { setPaidAmount(e.value); setPaidAmountError(''); }}
                      className={paidAmountError ? 'p-invalid' : ''}
                      aria-describedby={paidAmountError ? 'paidAmount-error' : undefined}
                      aria-invalid={!!paidAmountError}
                      mode="decimal"
                      minFractionDigits={0}
                      maxFractionDigits={2}
                    />
                    {paidAmountError && <small id="paidAmount-error" className="p-error p-d-block" role="alert">{paidAmountError}</small>}
                  </div>
                )}
                <div className="p-field">
                  <label htmlFor="actionNote">{t('fieldNote')}</label>
                  <InputText
                    id="actionNote"
                    value={actionNote}
                    onChange={(e) => setActionNote(e.target.value)}
                  />
                </div>
              </div>
            </Dialog>


        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>{t('moduleNoAccess')}</span>
          {t('moduleNoAccessContact')} {process.env.REACT_APP_DEVOPS_CONTACT} {t('emailAddressSuffix')}
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;{t('subscriptionAccountOverview')}
                       </a>
                   </span>
          }
        </p>
      )
      }
    </div>
  )
}
export default withTranslation('common')(FinancePage);
